import { useState } from "react";
import {
  Menu,
  Stack,
  Avatar,
  Button,
  MenuItem,
  Typography,
} from "@mui/material";

import LogoutMenu from "./LogoutMenu";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useGetUserLogin } from "../Hooks/useGetUserLogin";



export default function TopMenuLogout() {

  const { data } = useGetUserLogin();
  const userLogin = JSON.parse(window.localStorage.getItem("userLogin"));
  // ================== Function menu logout ===================
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // ================== Function open logout ===================
  const [oepnLogout, setOpenLogout] = useState(false);
  const handleCloseLogout = () => setOpenLogout(false);
  const handleOpenLogout = () => {
    setOpenLogout(true);
    handleClose();
  };

  return (<Stack direction="column" justifyContent="center">
    <Button className="btn-menu" onClick={handleClick}>
      <Stack direction="row" spacing={1}>
        <Stack direction="column" justifyContent="center">
          <Avatar
            src={data?.profile || userLogin?.profile || ""}
            alt="User"
            sx={{ width: 37, height: 37 }}
          />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="username-text">
            {data?.lastNameKh || userLogin?.lastNameKh || "User Log"}
          </Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          {openMenu ? (
            <ArrowDropUpIcon className="icon-menu" />
          ) : (
            <ArrowDropDownIcon className="icon-menu" />
          )}
        </Stack>
      </Stack>
    </Button>

    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={openMenu}
      onClose={handleClose}
      onClick={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuItem onClick={handleOpenLogout}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <LogoutIcon sx={{ color: "red" }} />
          <Typography>Logout </Typography>
        </Stack>
      </MenuItem>
    </Menu>

    <LogoutMenu open={oepnLogout} handleClose={handleCloseLogout} />
  </Stack>)
}
